import { Filter } from 'common/repositories/common.model';
import React from 'react';

import useFilterHandleTransformer from './use-filter-handle-transformer';

export type FilterHandleParentContextType = {
  page?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  filters: Filter[];
  setFilters: React.Dispatch<React.SetStateAction<Filter[]>>;
  onClearFilters: (filters: Filter[]) => void;
  onChangeFilters: (filters: Filter[]) => void;
  onChangeFilter: (name: string, value: any) => void;
  onSelected: (name: string) => (value: any) => void;
  onClearFilter: (name: string) => () => void;
  onGetSelectedFilter: (name: string) => Filter | undefined;
  filtersHasValues: boolean;
  filtersHasValuesCount: number;
  onCheckFiltersHasValues: (_filters?: Filter[]) => boolean;
};

const FilterHandleParentContext =
  React.createContext<FilterHandleParentContextType>({
    filters: [],
    setFilters(_) {},
    onClearFilters() {},
    onChangeFilters(_) {},
    onChangeFilter(_, __) {},
    onSelected: (_) => (__) => {},
    onClearFilter: (_) => () => {},
    onGetSelectedFilter: (_) => undefined,
    filtersHasValues: false,
    onCheckFiltersHasValues(_) {
      return false;
    },
    filtersHasValuesCount: 0,
  });

interface FilterHandleParentProviderProps {
  children: React.ReactNode;
  values: {
    page?: number;
    setPage?: React.Dispatch<React.SetStateAction<number>>;
    filters: Filter[];
    setFilters: React.Dispatch<React.SetStateAction<Filter[]>>;
  };
}

export function FilterHandleParentProvider(
  props: FilterHandleParentProviderProps,
) {
  const { setFilters, setPage, filters = [] } = props.values;
  const handler = useFilterHandleTransformer(filters, setFilters, setPage);

  return (
    <FilterHandleParentContext.Provider
      value={{
        ...props.values,
        ...handler,
      }}
    >
      {props.children}
    </FilterHandleParentContext.Provider>
  );
}

export default function useFilterHandleParent() {
  const context = React.useContext(FilterHandleParentContext);
  return context;
}
